import plugin from 'tailwindcss/plugin'
import tailwindForms from '@tailwindcss/forms'

export default {
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },
  separator: '_',
  theme: {
    extend: {
      boxShadow: {
        inner: 'inset 0 2px 8px 0 rgba(0, 0, 0, 0.1)',
        normal: '0 1px 4px 0 rgba(0,0,0,0.16)',
      },
      spacing: {
        '-1': '-0.25rem',
        0: '0',
        1: '0.25rem',
        2: '0.5rem',
        3: '0.75rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        9: '2.25rem',
        10: '2.5rem',
        11: '2.75rem',
        12: '3rem',
        14: '3.5rem',
        16: '4rem',
        18: '4.5rem',
        24: '6rem',
        28: '7rem',
        30: '7.5rem',
        32: '8rem',
        36: '9rem',
        38: '9.5rem',
        42: '10.5rem',
        47: '11.75rem',
        54: '13.5rem',
        64: '16rem',
        72: '18rem',
        76: '19rem',
        80: '20rem',
        88: '22rem',
        96: '24rem',
        100: '25rem',
        112: '28rem',
        160: '40rem',
        '55vh': '55vh',
        '70vh': '70vh',
        'footer-height': '315px',
      },
      inset: {
        1: '0.25rem',
        2: '0.5rem',
        3: '0.75rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        12: '3rem',
        14: '3.5rem',
        16: '4rem',
        17: '4.25rem',
        18: '4.5rem',
        20: '5rem',
        21: '5.25rem',
        22: '5.5rem',
        23: '5.75rem',
        24: '6rem',
        28: '7rem',
        32: '8rem',
        33: '8.25rem',
        34: '8.5rem',
        '2px': '2px',
      },
      height: {
        7: '1.75rem',
        7.5: '1.875rem',
        13: '3.25rem',
        15: '3.75rem',
        15.5: '3.875rem',
        22.5: '5.625rem',
        27.5: '6.875rem',
        34: '8.5rem',
        88: '22rem',
        121: '30.25rem',
        175: '43.75rem',
        '1/2': '50%',
        'min-content': 'min-content',
        inherit: 'inherit',
      },
      minHeight: {
        56: '14rem',
        64: '16rem',
        80: '20rem',
      },
      maxHeight: {
        172: '43rem',
        'min-content': 'min-content',
        '4/5': '80%',
      },
      width: {
        '3/4': '75%',
        '3/10': '30%',
        7.5: '1.875rem',
        13: '3.25rem',
        15: '3.75rem',
        15.5: '3.875rem',
        22.5: '5.625rem',
        27.5: '6.875rem',
        58: '14.5rem',
        64: '16.1875rem',
        110: '27.625rem',
        128: '32rem',
        192: '48rem',
        256: '64rem',
        fit: 'fit-content',
      },
      maxWidth: {
        64: '16rem',
        72: '18rem',
        108: '27rem',
        144: '36rem',
        192: '48rem',
        200: '50rem',
        '1/2': '50%',
        '3/4': '75%',
        '4/5': '80%',
        fit: 'fit-content',
      },
      minWidth: {
        48: '12rem',
        60: '15rem',
        64: '16rem',
        128: '32rem',
        192: '48rem',
        inherit: 'inherit',
        fit: 'fit-content',
      },
      transitionDuration: {
        400: '400ms',
      },
      colors: {
        transparent: 'transparent',
        brown: '#957861',
        bronze: {
          50: '#F4F0EC',
          100: '#F1DFD0',
          200: '#E6C0A2',
          300: '#DCA570',
          400: '#B98768',
          500: '#A88777',
          600: '#A36D4B',
          700: '#94542C',
          800: '#80563B',
          900: '#80563B',
        },
        blue: {
          50: '#EBF0F4',
          100: '#F0F9FF',
          200: '#DEEBFF',
          300: '#D1DAE1',
          400: '#9CA8B4',
          500: '#6C7982',
          600: '#445873',
          700: '#007BFF',
          800: '#13368E',
          900: '#08234F',
        },
        copper: {
          50: '#F0FDFA',
          100: '#EAEEEF',
          200: '#D3EFEC',
          300: '#C7D9D6',
          400: '#97ACB0',
          500: '#74A9B2',
          600: '#6D8B91',
          700: '#3F808C',
          800: '#2F5A62',
          900: '#213F45',
        },
        earth: {
          100: '#FCF8F5',
          200: '#F4F0EC',
          300: '#ECE4D9',
          400: '#E6DBCF',
          500: '#E6D7C0',
          600: '#B5AFA2',
          700: '#B0A69C',
          800: '#736156',
        },
        gold: {
          50: '#F5BC22',
          100: '#FFF7ED',
          200: '#FDECD3',
          300: '#FCE3BD',
          400: '#E6D7C0',
          500: '#CABBA0',
          600: '#D4BB94',
          700: '#B59F7F',
          800: '#C9A36E',
          900: '#AC8445',
        },
        gray: {
          50: '#FAFAFA',
          100: '#F4F4F4',
          200: '#EAEAEA',
          300: '#E1E1E1',
          400: '#CACACA',
          450: '#E0E0E0', // tailwind
          500: '#B3B3B3',
          550: '#6B7280', // tailwind
          600: '#959595',
          650: '#dfe6e9', // old vrify
          700: '#747474',
          750: '#616161', // old vrify
          800: '#4B4B4B',
          850: '#979797', // old vrify
          900: '#222222',
          950: '#414141', // old vrify
        },
        green: {
          100: '#FBFBF3',
          200: '#D6D6CF',
          300: '#D4DDD2',
          400: '#B4C6BC',
          450: '#10B981',
          500: '#869083',
          600: '#727A6D',
          800: '#657A72',
          900: '#224039',
          speaker: '#6EE7B7',
        },
        plum: {
          600: '#881337',
        },
        red: {
          100: '#FFE4E6',
          200: '#FECACA',
          500: '#FCA5A5',
          700: '#E65D7B',
          800: '#E11D48',
        },
        rose: {
          600: '#E11D48',
        },
      },
      flexGrow: {
        2: 2,
        3: 3,
      },
      zIndex: {
        '-10': '-10',
        70: '70',
      },
      translate: {
        double: '200%',
      },
      cursor: {
        grab: 'grab',
      },
    },
    container: {
      padding: {
        DEFAULT: '1.5rem',
      },
      center: true,
      // Exclude the xl3 breakpoint
      screens: {
        sm: '37.5rem', // 600px
        md: '48rem', // 768px
        lg: '56.25rem', // 900px
        xl: '62rem', // 992px
        xl1: '75rem', // 1200px
        xl2: '96rem', // 1536px
      },
    },
    fontFamily: {
      regular: ['Inter', 'Helvetica', 'Arial', 'sans-serif'],
      sans: ['Inter', 'Helvetica', 'Arial', 'sans-serif'],
      inter: ['Inter', 'Helvetica', 'Arial', 'sans-serif'],
      lora: ['Lora', 'Helvetica', 'Arial', 'sans-serif'],
      sfPro: ['SF Pro Text', 'Helvetica', 'Arial', 'sans-serif'],
      serif: ['Unna', 'serif'],
    },
    screens: {
      // configured to follow breakpoints set in assets/styl/_mixins.styl
      // mobile-only
      sm: '37.5rem', // 600px
      // mobile-landscape
      md: '48rem', // 768px
      // tablet-portrait-up
      lg: '56.25rem', // 900px
      // desktop-small
      xl: '62rem', // 992px
      // desktop-lg
      xl1: '75rem', // 1200px
      // desktop-xl,
      xl2: '96rem', // 1536px
      // desktop-3xl
      xl3: '120rem', //1920
    },
  },
  variants: {
    extend: {
      borderWidth: ['hover', 'focus'],
      opacity: ['hover'],
      padding: ['focus-within'],
      cursor: ['focus-within'],
      whitespace: ['focus-within'],
    },
  },
  plugins: [
    tailwindForms,
    plugin(function ({ addUtilities, theme }: any) {
      const screenSizeVar = {
        ':root': { '--screen-size': '100%' },
        [`@media(min-width: ${theme('screens.sm')})`]: { ':root': { '--screen-size': theme('screens.sm') } },
        [`@media(min-width: ${theme('screens.md')})`]: { ':root': { '--screen-size': theme('screens.md') } },
        [`@media(min-width: ${theme('screens.lg')})`]: { ':root': { '--screen-size': theme('screens.lg') } },
        [`@media(min-width: ${theme('screens.xl')})`]: { ':root': { '--screen-size': theme('screens.xl') } },
        [`@media(min-width: ${theme('screens.xl1')})`]: { ':root': { '--screen-size': theme('screens.xl1') } },
        [`@media(min-width: ${theme('screens.xl2')})`]: { ':root': { '--screen-size': theme('screens.xl2') } },
      }
      const textShadow = {
        '.text-shadow': {
          'text-shadow': '0 1px 2px rgb(0 0 0 / 80%)'
        }
      }

      // todo: move this to the Tailwind Base layer once we re-enable it
      addUtilities({ ...screenSizeVar, ...textShadow })
    }),
  ],
  content: [
    'components/**/*.vue',
    'layouts/**/*.vue',
    'pages/**/*.vue',
    'plugins/**/*.*',
    'nuxt.config.ts',
    'node_modules/@vrifytechnology/vrify-component-library/dist/**/*.js',
  ],
  safelist: [{ pattern: /(bg|text)-(.+)-(\d{1,3})/ }],
}
